import React, {useMemo, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {useRecoilValue} from 'recoil';
import {Capacitor} from '@capacitor/core';

import styles from './styles.module.scss';
import {isMobile, switchNewLineTxt} from '../../../utils';
import {user, UserInfo} from '../../../store/user';
import Carousel from '../../common/Carousel';
import {HomeKnewZipCard, HomeKnewZipIdx} from '../../../store';
import useLogger, {Action} from '../../../hooks/useLogger';

export default function KnewZip() {
  const navigator = useNavigate();
  const [activeIndex, setActiveIndex] = useState(0);
  const userInfo = useRecoilValue(UserInfo);
  const accessToken = useRecoilValue(user);
  const _zipItems = useRecoilValue(HomeKnewZipCard);
  const _zipIdx = useRecoilValue(HomeKnewZipIdx);
  const sender = useLogger();

  const lastSize = useMemo(() => {
    if (Capacitor.getPlatform() === 'web') {
      if (isMobile()) {
        return innerWidth - 325;
      }
      return 375 - 325;
    }
    return innerWidth - 325;
  }, [innerWidth]);

  return (
    <div>
      <div className={styles.title_wrapper}>
        <span className={styles.title}>
          {userInfo && userInfo.nickname
            ? userInfo.nickname + '님을 위한 오늘의 PICK'
            : '회원님을 위한 오늘의 PICK'}
        </span>
      </div>
      {_zipItems[_zipIdx] && _zipItems[_zipIdx].length > 0 && (
        <div className={styles.scroller}>
          <Carousel
            autoPlay={false}
            infiniteLoop={false}
            size={290}
            lastSize={lastSize}
            onChange={(idx: number) => setActiveIndex(idx)}>
            {_zipItems[_zipIdx].map((item, idx) => {
              if (item.type == 'foodlife') {
                return (
                  <div
                    className={`${styles.item} ${
                      activeIndex === idx ? styles.active : styles.inactive
                    }`}
                    key={item.id}
                    style={{
                      background: `url("${item.imageUrl}") no-repeat center / cover`,
                    }}
                    onClick={() => {
                      sender({
                        _msg: 'home_zip_recomm_img',
                        _screen: 'Zip/' + _zipItems[_zipIdx][0].id,
                        _action: Action.CLICK,
                        _data: {to: _zipItems[_zipIdx][0]},
                      });
                      navigator(`/zip/${_zipItems[_zipIdx][0].id}`, {
                        state: {
                          prev: 'home',
                        },
                      });
                    }}>
                    <div
                      className={styles.contents_title}
                      dangerouslySetInnerHTML={{
                        __html: switchNewLineTxt(item.title || ''),
                      }}></div>
                  </div>
                );
              } else {
                return (
                  <div
                    key={item.id}
                    className={`${styles.item} ${
                      activeIndex === idx ? styles.active : styles.inactive
                    }`}
                    onClick={() =>
                      navigator(`/zip/${_zipItems[_zipIdx][0].id}`, {
                        state: {
                          prev: 'home',
                        },
                      })
                    }>
                    {!accessToken && (
                      <div className={styles.inner_not_login}>
                        <div className={styles.info_txt}>
                          <strong>브랜드 정보가 궁금하다면?</strong>
                          <button
                            onClick={$event => {
                              $event.stopPropagation();
                              navigator('/login');
                            }}>
                            로그인하고 모두 보기
                          </button>
                        </div>
                      </div>
                    )}
                    <div
                      className={styles.brands_image}
                      style={{
                        background: `url("${item.thumbnailUrl}") no-repeat center / cover`,
                      }}></div>
                    <div className={styles.brands_text_wrapper}>
                      <div
                        className={styles.brands_title}
                        dangerouslySetInnerHTML={{
                          __html: switchNewLineTxt(item.title || ''),
                        }}></div>
                      <div className={styles.brands_info}>{item.info}</div>
                    </div>
                  </div>
                );
              }
            })}
          </Carousel>
        </div>
      )}
    </div>
  );
}
